import { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../component/table/tableCustom';
import TableRowCommon from '../../../component/table/TableRowCommon';
import { MenuItem } from '@mui/material';
import ButtonCustom from '../../../component/button/buttonCustom';
import { icons } from '../../../constants/images'
import FilterSelect from '../../../component/select/filterSelect';
import RoleApi from '../../../api/role/role.api';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function ListRoles() {
    const { t } = useTranslation();
    const { profile, loading } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []

    const navigate = useNavigate()
    const [sortBy, setSortBy] = useState<string>('')
    const [sortType, setSortType] = useState<string>('ASC')
    const [data, setData] = useState<any>([])
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [totalItem, setTotalItem] = useState<number>(3);

    const onRequestSort = (sortBy: string, sortType: string) => {
        setSortType(sortType)
        setSortBy(sortBy)
    }

    const changeStatus = async (value: string, objData: any) => {
        await RoleApi.patchRole(objData?.idRole, { ...objData, roleStatus: value }).then((res) => {
            if (res?.data?.success) {
                swalSuccess(t('ROLE.SWAL.EDIT_STATUS_SUCCESS'))
                loadData()
            } else {
                swalError(res.response.data.description || res.response.data.message);

            }

        }).catch((error: any) => {
            swalError(error.response.data.description || error.response.data.message);
        })
    }

    const loadData = useCallback(async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        if (sortBy) condition = { ...condition, sortBy: sortBy };
        if (sortType) condition = { ...condition, sortType: sortType };
        RoleApi.getRoles(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setData(items);
                setPage(meta.currentPage)
                setRowCount(meta.totalItems)
                setTotalItem(meta.totalItems)
                setTotalPages(meta.totalPages)
            }
        });
    }, [page, pageLimit, sortBy, sortType]);

    useEffect(() => {
        loadData()
    }, [loadData])


    const headCells = [
        {
            id: "roleName",
            label: t('ROLE.HEADCELL.ROLE'),
            align: "left",
            colSpan: 1,
            sortable: true
        },
        {
            id: "roleStatus",
            label: t('ROLE.HEADCELL.STATUS'),
            align: "center",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { roleName, idRole, roleStatus } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: idRole,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: roleName },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            <FilterSelect
                                disabled={!permit.find((x: any) => x?.code === 'Role.Edit')?.permit}
                                labelId='' selectId='' style={{
                                    '& .MuiSelect-select': {
                                        backgroundColor: roleStatus === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                        color: roleStatus === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                        margin: '0px 30px 0px 6px',
                                        padding: '5px 0px',
                                    }
                                }} options={[{ value: 'เปิดใช้งาน', name: t('EMPLOYEES.STATUS.ACTIVE') }, { value: 'ไม่ใช้งาน', name: t('EMPLOYEES.STATUS.UNACTIVE') }].map((x, i) => {
                                    return (
                                        <MenuItem key={i}
                                            value={x.value}
                                            sx={{
                                                backgroundColor: x.value === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                                color: x.value === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                            }}
                                        >
                                            ● {x.name}
                                        </MenuItem>
                                    )
                                })} value={roleStatus} onchange={(e: any) => { changeStatus(e.target.value, objData) }} />
                        </>
                    )
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            {permit.find((x: any) => x?.code === 'Role.Edit')?.permit && <icons.editTable onClick={() => navigate('/role/detail/' + idRole, { state: { idRole: idRole } })} style={{ cursor: "pointer" }} />}
                        </>
                    )
                }

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>{t('ROLE.TITLE')}</TitleText>
                {permit.find((x: any) => x?.code === 'Role.Add')?.permit && <ButtonCustom variant={'outlined'}
                    startIcon={<icons.circleButton />}
                    textButton={t('ROLE.BUTTON.CREATE')}
                    onClick={() => navigate('/role/add')} />}
            </LayoutTitle>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={sortType}
                sortBy={sortBy}
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={onRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
            />

        </LayoutView >
    )
}
